const B_1 = [
    {
        title: '评标办法验证',
        path: '/bidding/projectflow/toubiao/bid-method-validate/list'
    }
]
export default {
    path: 'bid-method-validate',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-toubiao-auditbmzl'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/tou/bid-method-validate/list'),
            meta: {
                title: '评标办法验证列表',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/tou/bid-method-validate/detail'),
            meta: {
                title: '评标办法详情',
                bread: B_1
            },
        },
    ]
}